module.exports = __webpack_public_path__ + "img/benefits.34dc1b22.svg";